import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import toast from 'react-hot-toast';

import { logout } from '../features/auth/authSlice'; // Adjust the import path as needed

const Logout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());  // Dispatch Redux logout action
    toast.success('Logged out successfully');
    navigate('/'); // Redirect to login page (adjust route if needed)
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8 }}>
        <Typography variant="h4" component="h2" align="center" gutterBottom>
          Logout
        </Typography>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography variant="body1">
            Are you sure you want to logout?
          </Typography>
        </Box>
        <Box sx={{ textAlign: 'center' }}>
          <LogoutButton variant="contained" onClick={handleLogout}>
            Logout
          </LogoutButton>
        </Box>
      </Box>
    </Container>
  );
};

const LogoutButton = styled(Button)({
  marginTop: '16px',
  backgroundColor: '#f44336', // Red color for logout button
  color: '#fff', // White text color
  '&:hover': {
    backgroundColor: '#d32f2f', // Darker red on hover
  },
});

export default Logout;
